module.exports = __webpack_public_path__ + "img/1.f1fe482d.jpg";